import { render, staticRenderFns } from "./OfferToro.vue?vue&type=template&id=54cf4eca&"
import script from "./OfferToro.vue?vue&type=script&lang=js&"
export * from "./OfferToro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports